import { Grid, styled } from '@mui/material';
import OfferCard from 'components/OfferCard';

export const StyledGrid = styled(Grid)`
  user-select: none;
  margin-top: 10px;
`;

export const StyledOfferCard = styled(OfferCard)``;
